import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../../configureStore";
import axios from "axios";
import { API } from "../../../../config";
import {
  initialState,
  resetAdvancedDeclarationOptionAndDeclarationOptions,
  resetCriteriaToBin,
  resetQualityCriteriaData,
  selecteBinIndex,
  selectedCriteria,
  setAllotmentPolicies,
  setBinCreationValues,
  setCancelValuestoEditLocation,
  setCriteriaToBin,
  setCriteriaValuesToDelete,
  setErrorUpdateDeleteBin,
  setLocationGrainTracker,
  setPrincipalInfoGT,
  setPrincipalInfoGTCopy,
  setEditBinAllotmentDone,
  setEditBinsDone,
  setDeleteAllotmentDone,
  setTheBinIsGood,
  setQualityCriteriaData,
  setDeleteBinSuccess,
  setDeleteBinError,
} from "../../../slices/grainTracker/grainTrackerEdition";

import { v4 as uuidv4 } from "uuid";

import { fetchStoragesOfEachLocation } from "./grainTrackerGetServicesEdition";

import { theBinIsGood } from "../../../../components/grainWise/create/GrainTrackerForm";
import { fetchAllotmentPoliciesEachBin } from "../grainTrackerGetServices";
import { fetchStoragesOfEachLocationLocationView } from "../../locations/locationDetailsAsync";

export const updateBin = createAsyncThunk(
  "GrainWiseEditionReducer/updateBin",
  async (token: string, store) => {
    const { locale } = (store.getState() as RootState).LayoutReducer;
    const {
      principalInfoGT,
      locationGrainTrackerValues,
      errorsUpdateDeleteBin,
      addingCriteria,
      selectedCriteriaToDelete,
      editBins,
      advancedDeclarationOptionSelected,
    } = (store.getState() as RootState).GrainWiseEditionReducer;

    const headers = {
      "Accept-Language": `${locale}`,
      Authorization: `Bearer ${token}`,
    };

    store.dispatch(
      setEditBinsDone({
        ...editBins,
        editedError: "",
        editedLoading: true,
      }),
    );

    try {
      const response = await axios.patch(
        `${API}/storages/storage-instance/${principalInfoGT.id}`,
        {
          name: principalInfoGT.name,
          storageTemplateId: principalInfoGT.storage,
          cerealTypeId: principalInfoGT.specie,
          capacityMetricTonsWheatEq: principalInfoGT.tonsCapacity,
        },
        { headers },
      );
      const { data } = response;

      if (
        addingCriteria.adding &&
        addingCriteria.values.allotmentOperator !== "in" &&
        addingCriteria.values.storageQualityCriterionId
      ) {
        store.dispatch(createStorageAllotmentPolicy({ token }));
      }

      if (
        addingCriteria.adding &&
        addingCriteria.values.allotmentOperator === "in" &&
        addingCriteria.values.storageQualityCriterionId &&
        advancedDeclarationOptionSelected.valuesSelected.length > 0
      ) {
        store.dispatch(createStorageAllotmentPolicy({ token }));
      } else {
        store.dispatch(resetAdvancedDeclarationOptionAndDeclarationOptions());
      }

      store.dispatch(selectedCriteria(undefined));
      store.dispatch(
        setCriteriaToBin({
          adding: false,
          values: {
            storageInstanceId: "",
            storageQualityCriterionId: "",
            allotmentOperator: "",
            allotmentValue: "",
            allotmentValueArray: [],
          },
        }),
      );

      store.dispatch(
        fetchStoragesOfEachLocation({
          token,
          orgGeoPointId: locationGrainTrackerValues.locationInformation
            ?.id as number,
        }),
      );

      const deleteAllotmentPromises = selectedCriteriaToDelete.map((values) => {
        return store.dispatch(deleteStorageAllotmentPolicy(values));
      });

      await Promise.all(deleteAllotmentPromises);

      store.dispatch(setCriteriaValuesToDelete([]));

      const updatedAllotmentPolicies = await fetchAllotmentPoliciesEachBin(
        token,
        locale,
        locationGrainTrackerValues.locationInformation?.id as number,
        principalInfoGT.id as string,
      );

      store.dispatch(setAllotmentPolicies(updatedAllotmentPolicies));

      store.dispatch(
        setPrincipalInfoGTCopy({
          name: data.name,
          specie: data.cerealTypeId,
          currentCharacteristics: data.currentCharacteristics,
          storage: data.storageTemplateId,
          allotmentPolicies: updatedAllotmentPolicies,
          tonsCapacity: data?.characteristics?.capacityMetricTonsWheatEq,
          id: data.id,
        }),
      );

      store.dispatch(
        setPrincipalInfoGT({
          name: data.name,
          specie: data.cerealTypeId,
          currentCharacteristics: data.currentCharacteristics,
          storage: data.storageTemplateId,
          allotmentPolicies: updatedAllotmentPolicies,
          tonsCapacity: data?.characteristics?.capacityMetricTonsWheatEq,
          id: data.id,
        }),
      );

      store.dispatch(
        setEditBinsDone({
          editedError: "",
          editedLoading: false,
          editedDone: !!data,
        }),
      );
      setTimeout(() => {
        store.dispatch(
          setEditBinsDone({
            editedError: "",
            editedLoading: false,
            editedDone: false,
          }),
        );
      }, 3000);

      store.dispatch(
        setTheBinIsGood(
          !theBinIsGood(
            data.cerealTypeId,
            data.storageTemplateId,
            data?.characteristics?.capacityMetricTonsWheatEq,
          ),
        ),
      );
    } catch (error: any) {
      store.dispatch(
        setEditBinsDone({
          ...editBins,
          editedError: error?.response?.data?.message,
          editedLoading: false,
        }),
      );
      store.dispatch(
        setErrorUpdateDeleteBin({
          ...errorsUpdateDeleteBin,
          updateBin: error?.response?.data?.message,
        }),
      );
    }
  },
);

export const updateBinSaveAndQuite = createAsyncThunk(
  "GrainWiseEditionReducer/updateBinSaveAndQuite",
  async (arg: { navigate: any }, store) => {
    const { locale } = (store.getState() as RootState).LayoutReducer;
    const { user } = (store.getState() as RootState).Authentication;

    const {
      principalInfoGT,
      locationGrainTrackerValues,
      errorsUpdateDeleteBin,
      addingCriteria,
      selectedCriteriaToDelete,
      editBins,
      advancedDeclarationOptionSelected,
    } = (store.getState() as RootState).GrainWiseEditionReducer;

    const token = user?.token ?? "";

    const headers = {
      "Accept-Language": `${locale}`,
      Authorization: `Bearer ${token}`,
    };

    store.dispatch(
      setEditBinsDone({
        ...editBins,
        editedError: "",
        editedLoading: true,
      }),
    );

    if (
      locationGrainTrackerValues.isEditingBin ||
      locationGrainTrackerValues.isAddingStorage
    ) {
      try {
        const response = await axios.patch(
          `${API}/storages/storage-instance/${principalInfoGT.id}`,
          {
            name: principalInfoGT.name,
            storageTemplateId: principalInfoGT.storage,
            cerealTypeId: principalInfoGT.specie,
            capacityMetricTonsWheatEq: principalInfoGT.tonsCapacity,
          },
          { headers },
        );
        const { data } = response;

        await fetchAllotmentPoliciesEachBin(
          token,
          locale,
          locationGrainTrackerValues.locationInformation?.id as number,
          principalInfoGT.id as string,
        );

        if (
          addingCriteria.adding &&
          addingCriteria.values.allotmentOperator !== "in" &&
          addingCriteria.values.storageQualityCriterionId
        ) {
          store.dispatch(createStorageAllotmentPolicy({ token }));
        }

        if (
          addingCriteria.adding &&
          addingCriteria.values.allotmentOperator === "in" &&
          addingCriteria.values.storageQualityCriterionId &&
          advancedDeclarationOptionSelected.valuesSelected.length > 0
        ) {
          store.dispatch(createStorageAllotmentPolicy({ token }));
        } else {
          store.dispatch(resetAdvancedDeclarationOptionAndDeclarationOptions());
        }

        store.dispatch(selectedCriteria(undefined));

        const deleteAllotmentPromises = selectedCriteriaToDelete.map(
          (values) => {
            return store.dispatch(deleteStorageAllotmentPolicy(values));
          },
        );

        await Promise.all(deleteAllotmentPromises);

        if (data) {
          arg.navigate(
            `/site/details/${locationGrainTrackerValues.locationInformation?.name}`,
          );

          store.dispatch(setCancelValuestoEditLocation());
          store.dispatch(resetCriteriaToBin());
          store.dispatch(resetQualityCriteriaData());
          store.dispatch(selectedCriteria(undefined));
          store.dispatch(setTheBinIsGood(false));
          store.dispatch(selecteBinIndex(undefined));
          store.dispatch(
            setLocationGrainTracker({
              ...initialState.locationGrainTrackerValues,
              isAddingStorage: false,
              isEditingBin: false,
            }),
          );
          store.dispatch(
            setEditBinsDone({
              ...editBins,
              editedError: "",
              editedLoading: false,
            }),
          );
        }
      } catch (error: any) {
        store.dispatch(
          setEditBinsDone({
            ...editBins,
            editedError: error?.response?.data?.message,
            editedLoading: false,
          }),
        );
        store.dispatch(
          setErrorUpdateDeleteBin({
            ...errorsUpdateDeleteBin,
            updateBin: error?.response?.data?.message,
          }),
        );
      }
    } else {
      arg.navigate(
        `/site/details/${locationGrainTrackerValues.locationInformation?.name}`,
      );
      setTimeout(() => {
        store.dispatch(setCancelValuestoEditLocation());
        store.dispatch(resetCriteriaToBin());
        store.dispatch(resetQualityCriteriaData());
        store.dispatch(selectedCriteria(undefined));
        store.dispatch(setTheBinIsGood(false));
        store.dispatch(selecteBinIndex(undefined));
        store.dispatch(
          setLocationGrainTracker({
            ...initialState.locationGrainTrackerValues,
            isAddingStorage: false,
            isEditingBin: false,
          }),
        );
        store.dispatch(
          setEditBinsDone({
            ...editBins,
            editedError: "",
            editedLoading: false,
          }),
        );
      }, 300);
    }
  },
);

export const deleteBin = createAsyncThunk(
  "GrainWiseEditionReducer/deleteBin",
  async (token: string, store) => {
    const { locale } = (store.getState() as RootState).LayoutReducer;

    const {
      principalInfoGT,
      locationGrainTrackerValues,
      errorsUpdateDeleteBin,
    } = (store.getState() as RootState).GrainWiseEditionReducer;

    const headers = {
      "Accept-Language": `${locale}`,
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.delete(
        `${API}/storages/storage-instance/${principalInfoGT.id}`,

        { headers },
      );
      const { data } = response;

      store.dispatch(
        setLocationGrainTracker({
          ...locationGrainTrackerValues,
          isAddingStorage: false,
          isEditingBin: false,
        }),
      );

      store.dispatch(setPrincipalInfoGT(initialState.principalInfoGT));
      store.dispatch(setPrincipalInfoGTCopy(initialState.principalInfoGT));

      store.dispatch(
        fetchStoragesOfEachLocation({
          token,
          orgGeoPointId: locationGrainTrackerValues.locationInformation
            ?.id as number,
        }),
      );
      store.dispatch(setDeleteBinSuccess(true));
      setTimeout(() => {
        store.dispatch(setDeleteBinSuccess(false));
      }, 4000);
      return data;
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.message ?? "Error deleting storage";
      store.dispatch(
        setErrorUpdateDeleteBin({
          ...errorsUpdateDeleteBin,
          errorDeleteBin: errorMsg,
        }),
      );
      store.dispatch(setDeleteBinError(errorMsg));
      setTimeout(() => {
        store.dispatch(setDeleteBinError(""));
      }, 4000);
    }
  },
);

export const addNewBin = createAsyncThunk(
  "GrainWiseEditionReducer/addNewBin",
  async (token: string, store) => {
    const {
      locationGrainTrackerValues,
      listOfStoragesTemplates,
      binCreation,
      principalInfoGT,
    } = (store.getState() as RootState).GrainWiseEditionReducer;
    const { locale } = (store.getState() as RootState).LayoutReducer;

    store.dispatch(setAllotmentPolicies([]));
    store.dispatch(resetQualityCriteriaData());

    const headers = {
      "Accept-Language": `${locale}`,
      Authorization: `Bearer ${token}`,
    };

    const StorageDefaultValue =
      listOfStoragesTemplates.storagesTemplates?.data[0];
    const name = StorageDefaultValue?.nameTextId.text;
    const id = StorageDefaultValue?.id;

    store.dispatch(setBinCreationValues({ ...binCreation, loading: true }));
    if (locationGrainTrackerValues.locationInformation) {
      try {
        const response = await axios.post(
          `${API}/storages/storage-instance`,
          {
            id: uuidv4(),
            name,
            cerealTypeId: 19,
            storageTemplateId: id,
            orgGeoPointId: locationGrainTrackerValues.locationInformation?.id,
          },
          { headers },
        );

        const { data } = response;

        store.dispatch(
          setLocationGrainTracker({
            ...locationGrainTrackerValues,
            isAddingStorage: true,
          }),
        );

        store.dispatch(
          fetchStoragesOfEachLocation({
            token,
            orgGeoPointId: locationGrainTrackerValues.locationInformation
              ?.id as number,
          }),
        );
        store.dispatch(
          setBinCreationValues({ ...binCreation, data, loading: false }),
        );

        ///values to possible modfy
        store.dispatch(
          setPrincipalInfoGT({
            ...principalInfoGT,
            name: data.name,
            specie: data.cerealTypeId,
            storage: data.storageTemplateId,
            id: data.id,
            tonsCapacity: 0,
            currentCharacteristics: data.currentCharacteristics,
            allotmentPolicies: data.allotmentPolicies,
          }),
        );
        ///values to copy when the user refresh
        store.dispatch(
          setPrincipalInfoGTCopy({
            ...principalInfoGT,
            name: data.name,
            specie: data.cerealTypeId,
            storage: data.storageTemplateId,
            id: data.id,
            tonsCapacity: 0,
            currentCharacteristics: data.currentCharacteristics,
            allotmentPolicies: data.allotmentPolicies,
          }),
        );
      } catch (error) {
        store.dispatch(
          setBinCreationValues({ ...binCreation, error, loading: false }),
        );
        return store.rejectWithValue(error);
      }
    } else {
      return store.rejectWithValue("No location");
    }
  },
);

export const createStorageAllotmentPolicy = createAsyncThunk(
  "GrainWiseEditionReducer/createStorageAllotmentPolicy",
  async (arg: { token: string }, store) => {
    const { locale } = (store.getState() as RootState).LayoutReducer;
    const {
      addingCriteria,
      locationGrainTrackerValues,
      principalInfoGT,
      advancedDeclarationOptionSelected,
      editBinAllotment,
    } = (store.getState() as RootState).GrainWiseEditionReducer;

    const {
      allotmentOperator,
      allotmentValue,
      storageInstanceId,
      storageQualityCriterionId,
    } = addingCriteria.values;

    store.dispatch(
      setEditBinAllotmentDone({
        ...editBinAllotment,
        editedError: "",
        editedLoading: true,
      }),
    );

    try {
      const response = await axios.post(
        `${API}/storages/storage-allotment-policy`,
        {
          storageInstanceId,
          storageQualityCriterionId,
          allotmentOperator,
          allotmentValue: allotmentValue.length === 0 ? null : allotmentValue,
          allotmentValueArray:
            advancedDeclarationOptionSelected.valuesSelected.length === 0 ||
            advancedDeclarationOptionSelected.valuesSelected === undefined
              ? null
              : advancedDeclarationOptionSelected.valuesSelected.map(
                  (val) => val.id,
                ),
        },
        {
          headers: {
            "Accept-Language": `${locale}`,
            Authorization: `Bearer ${arg.token}`,
          },
        },
      );
      const { data } = response;

      const allotmentPolicies = await fetchAllotmentPoliciesEachBin(
        arg.token,
        locale,
        locationGrainTrackerValues.locationInformation?.id as number,
        principalInfoGT.id as string,
      );

      store.dispatch(
        fetchStoragesOfEachLocation({
          token: arg.token,
          orgGeoPointId: locationGrainTrackerValues.locationInformation
            ?.id as number,
        }),
      );
      store.dispatch(
        fetchStoragesOfEachLocationLocationView({
          token: arg.token,
          orgGeoPointId: locationGrainTrackerValues.locationInformation
            ?.id as number,
        }),
      );

      store.dispatch(setAllotmentPolicies(allotmentPolicies));

      store.dispatch(
        setEditBinAllotmentDone({
          editedError: "",
          editedLoading: false,
          editedDone: !!data,
        }),
      );
      setTimeout(() => {
        store.dispatch(resetAdvancedDeclarationOptionAndDeclarationOptions());
        store.dispatch(
          setEditBinAllotmentDone({
            editedError: "",
            editedLoading: false,
            editedDone: false,
          }),
        );
      }, 3000);

      return data;
    } catch (error: any) {
      store.dispatch(
        setEditBinAllotmentDone({
          ...editBinAllotment,
          editedError: error?.response?.data?.message,
          editedLoading: false,
        }),
      );
    }
  },
);

export const deleteStorageAllotmentPolicy = createAsyncThunk(
  "GrainWiseEditionReducer/deleteStorageAllotmentPolicy",
  async (policyToDeleteId: string, store) => {
    const { locale } = (store.getState() as RootState).LayoutReducer;
    const { user } = (store.getState() as RootState).Authentication;
    const token = user?.token ?? "";
    const {
      locationGrainTrackerValues,
      principalInfoGT,
      deleteAllotmentPolicies,
    } = (store.getState() as RootState).GrainWiseEditionReducer;

    store.dispatch(
      setEditBinAllotmentDone({
        ...deleteAllotmentPolicies,
        deleteError: "",
        deleteLoading: true,
      }),
    );

    try {
      const response = await axios.delete(
        `${API}/storages/storage-allotment-policy/${policyToDeleteId}`,

        {
          headers: {
            "Accept-Language": `${locale}`,
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const { data } = response;
      store.dispatch(setCriteriaValuesToDelete([]));

      const allotmentPolicies = await fetchAllotmentPoliciesEachBin(
        token,
        locale,
        locationGrainTrackerValues.locationInformation?.id as number,
        principalInfoGT.id as string,
      );

      store.dispatch(setAllotmentPolicies(allotmentPolicies));
      store.dispatch(
        fetchStoragesOfEachLocation({
          token: token,
          orgGeoPointId: locationGrainTrackerValues.locationInformation
            ?.id as number,
        }),
      );
      store.dispatch(
        fetchStoragesOfEachLocationLocationView({
          token: token,
          orgGeoPointId: locationGrainTrackerValues.locationInformation
            ?.id as number,
        }),
      );

      store.dispatch(
        setDeleteAllotmentDone({
          deleteError: "",
          deleteLoading: false,
          deleteDone: !!data,
        }),
      );
      setTimeout(() => {
        store.dispatch(
          setDeleteAllotmentDone({
            deleteError: "",
            deleteLoading: false,
            deleteDone: false,
          }),
        );
      }, 3000);

      return data;
    } catch (error: any) {
      store.dispatch(
        setDeleteAllotmentDone({
          ...deleteAllotmentPolicies,
          deleteError: error?.response?.data?.message,
          deleteLoading: false,
        }),
      );
    }
  },
);
